import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "p-4"
};
import { db as gameDb } from "@/modules/base/services/db";
import { app, container } from "@/di";
import { GameCreator } from "@/modules/base/services/gameCreator";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Progress from "@/modules/vue/components/Progress.vue";
import { SectionLoader } from "@/modules/base/services/SectionLoader";
export default /*#__PURE__*/_defineComponent({
  __name: 'Creating',
  async setup(__props) {
    let __temp, __restore;
    const loader = ref();
    const isLoading = ref(false);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(() => useInitial(async () => {
      loader.value = app.get(SectionLoader);
    })), __temp = await __temp, __restore(), __temp);
    const current = computed(() => loader.value.getCurrentSectionIndex() + 1);
    const status = computed(() => loader.value.isFinished() ? 'finish' : 'process');
    const route = useRoute();
    const router = useRouter();
    onMounted(async () => {
      isLoading.value = true;
      await gameDb.synchronize(true);
      await container.get(GameCreator).generate(JSON.parse(route.query.options), loader.value);
      router.push({
        name: 'index'
      });
    });
    return (_ctx, _cache) => {
      const _component_NStep = _resolveComponent("NStep");
      const _component_NSteps = _resolveComponent("NSteps");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-header": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('creating_game')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NSteps, {
          vertical: "",
          current: _unref(current),
          status: _unref(status)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loader.value.getSections(), section => {
            return _openBlock(), _createBlock(_component_NStep, {
              key: section.name,
              title: section.name
            }, {
              default: _withCtx(() => [section.total > 1 ? (_openBlock(), _createBlock(Progress, {
                key: 0,
                value: Math.min(100, section.current / section.total * 100)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(section.current) + " / " + _toDisplayString(section.total), 1)]),
                _: 2
              }, 1032, ["value"])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["title"]);
          }), 128))]),
          _: 1
        }, 8, ["current", "status"])])]),
        _: 1
      });
    };
  }
});